import {authAxios} from "./axiosClient";
import { listLichSuChamCongURL, listLichSuChinhSuaURL,
} from "../constants";

export const lichSuChinhSuaApi = (params={})=>{
        return authAxios().get(listLichSuChinhSuaURL,{params})
}

export const lichSuChamCongApi = (params={})=>{
        return authAxios().get(listLichSuChamCongURL,{params})
}

